<!--
 * @description: 
 * @author: Jason Wong
 * @since: 2021-12-14 10:23:42
-->
<script>
export default {
  props: {
    title: {
      type: String,
    },
    label: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      block: {},
    };
  },
  methods: {
    getBlockRender() {
      return (h, form, data) => {
        this.$forceUpdate();
        const scopeSlotFunc =
          form == "fold" ? this.$scopedSlots.fold : this.$scopedSlots.default;
        return h(
          "div",
          {
            class: "component--ribbon__panel-block",
          },
          [
            h(
              "div",
              { class: "inner-space" },
              scopeSlotFunc ? scopeSlotFunc(data) : null
            ),
            h("div", { class: "title-space" }, [this.title || "-"]),
          ]
        );
      };
    },
  },
  created() {
    this.block = {
      label: this.label,
      title: this.title,
      stubRef: this,
      render: this.getBlockRender().bind(this),
    };
    this._owner = this.$parent;
    this._owner.addBlock(this.block);
  },
  render(h) {
    return h("div");
    //return this.getBlockRender()(h, "expand", null);
  },
  mounted() {},
  updated() {
    //this.$parent.$emit("block-update");
  },
  destroyed() {
    this._owner.removeBlock(this.block);
  },
};
</script>

<style lang="scss">
.component--ribbon__panel-block {
  height: 100%;

  .inner-space {
    height: 64px;
    overflow: visible;
    display: flex;
    flex-direction: row;
    > * {
      margin-left: 8px;
      &:first-child {
        margin-left: 0;
      }
    }
  }
  .title-space {
    flex-shrink: 0;
    line-height: 16px;
    height: 16px;
    text-align: center;
    font-size: 12px;
    color: #909399;
  }
}
</style>